import React from 'react';

function AboutUs() {
  return (
    <div className="tab-content">
      <h2>About Us</h2>
      <div style={{ marginBottom: '30px' }}>
        <p style={{ fontSize: '16px', lineHeight: '1.8', marginBottom: '15px' }}>
          <strong>GLOBAL RESEARCH ORGANISATION</strong> is World's first central accreditation and research support forum.
          We certify and monitor thesis makers, research consultants, statisticians, and editors across the world
          to ensure transparency, originality, and accountability in academic research assistance.
        </p>
        <p style={{ fontSize: '16px', lineHeight: '1.8' }}>
          We provide digital verification, barcode-based identity, and legal assistance
          to promote ethical research culture in India.
        </p>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ color: '#2c3e50', borderBottom: '2px solid #3498db', paddingBottom: '10px', marginBottom: '20px' }}>
          Vision & Mission
        </h3>
        <p style={{ fontSize: '15px', lineHeight: '1.8', marginBottom: '12px' }}>
          <strong style={{ color: '#2980b9' }}>Vision:</strong> To make World's academic research ecosystem trustworthy, transparent, and fair.
        </p>
        <p style={{ fontSize: '15px', lineHeight: '1.8', marginBottom: '12px' }}>
          <strong style={{ color: '#2980b9' }}>Mission:</strong> To protect students and customers from fraud, verify genuine service providers,
          provide legal support, and promote ethical research through accreditation.
        </p>
        <p style={{ fontSize: '15px', lineHeight: '1.8' }}>
          <strong style={{ color: '#2980b9' }}>Objectives:</strong> Establish a transparent verification system, create a national
          directory of certified providers, offer legal protection to all stakeholders, promote research ethics,
          and provide financial support to deserving research projects.
        </p>
      </div>


      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ color: '#2c3e50', borderBottom: '2px solid #3498db', paddingBottom: '10px', marginBottom: '20px' }}>
          How Our System Works
        </h3>
        <ol style={{ fontSize: '15px', lineHeight: '2', paddingLeft: '20px' }}>
          <li style={{ marginBottom: '10px' }}>
            <strong>Thesis Maker Registration:</strong> Providers apply for verification through our website.
          </li>
          <li style={{ marginBottom: '10px' }}>
            <strong>Verification Process:</strong> We check plagiarism reports, refund policy, ID proof, and client feedback.
          </li>
          <li style={{ marginBottom: '10px' }}>
            <strong>Barcode & Profile ID:</strong> Verified providers get a digital certificate and QR-based barcode.
          </li>
          <li style={{ marginBottom: '10px' }}>
            <strong>Transparency Portal:</strong> Students scan barcode to check authenticity, complaints, and reviews.
          </li>
          <li style={{ marginBottom: '10px' }}>
            <strong>Legal Assistance:</strong> We support both parties in fraud or refund disputes.
          </li>
        </ol>
      </div>

      <div style={{ marginTop: '40px' }}>
        <h3 style={{ color: '#2c3e50', borderBottom: '2px solid #3498db', paddingBottom: '10px', marginBottom: '20px' }}>
          Our Services
        </h3>

        <div style={{ marginBottom: '25px' }}>
          <h4 style={{ color: '#27ae60', fontSize: '18px', marginBottom: '15px' }}>For Students:</h4>
          <ul style={{ fontSize: '15px', lineHeight: '2', paddingLeft: '20px', listStyleType: 'disc' }}>
            <li style={{ marginBottom: '8px' }}>Fraud Alert Portal and verified provider directory</li>
            <li style={{ marginBottom: '8px' }}>Legal and consumer protection assistance</li>
            <li style={{ marginBottom: '8px' }}>Free research resources and plagiarism check support</li>
          </ul>
        </div>

        <div>
          <h4 style={{ color: '#3498db', fontSize: '18px', marginBottom: '15px' }}>For Providers:</h4>
          <ul style={{ fontSize: '15px', lineHeight: '2', paddingLeft: '20px', listStyleType: 'disc' }}>
            <li style={{ marginBottom: '8px' }}>Accreditation and barcode verification</li>
            <li style={{ marginBottom: '8px' }}>Listing on national directory</li>
            <li style={{ marginBottom: '8px' }}>Legal and contractual protection</li>
            <li style={{ marginBottom: '8px' }}>Branding and recognition through GLOBAL RESEARCH ORGANISATION badge</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default AboutUs;
